module.exports = __webpack_public_path__ + "img/Arabic-11.2e60fc95.jpg";